import { z } from 'zod';

import { EmployeeStatus, JobHistoryLevel } from '@/common/graphql';

export const EmployeeSearchFilter = z.object({
  keyword: z.string().default(''),
  statuses: z.array(z.nativeEnum(EmployeeStatus)).catch([]),
  levels: z.array(z.nativeEnum(JobHistoryLevel)).catch([]),
  companyIds: z.array(z.string()).catch([]),
  countryIds: z.array(z.string()).catch([]),
  businessUnitIds: z.array(z.string()).catch([]),
  departmentIds: z.array(z.string()).catch([]),
  jobIds: z.array(z.string()).catch([]),
});

export type EmployeeSearchFilterType = z.infer<typeof EmployeeSearchFilter>;
